// src/components/PubliekePagina.js
// Het kader van de publieke doorloopjespagina's (overzicht en voorvertoning): header, footer,
// inloggen, registreren, privacy en contact. Na inloggen of registreren gaat de bezoeker naar
// naInloggen. De inhoud is een functie die openLogin en openRegister meekrijgt.
import React, { useState, useEffect } from 'react';
import axios from 'axios';

import Header from './Header';
import Footer from './Footer';
import LoginModal from './LoginModal';
import RegistrationModal from './RegistrationModal';
import InfoModal from './InfoModal';

const STRAPI_URL = process.env.REACT_APP_STRAPI_URL;

function PubliekePagina({ naInloggen, children }) {
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
  const [isRegisterModalOpen, setIsRegisterModalOpen] = useState(false);
  const [isPrivacyModalOpen, setIsPrivacyModalOpen] = useState(false);
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);
  const [privacyData, setPrivacyData] = useState(null);
  const [contactData, setContactData] = useState(null);

  useEffect(() => {
    const fetchFooterData = async () => {
      try {
        const [privacyRes, contactRes] = await Promise.all([
          axios.get(`${STRAPI_URL}/api/privacyverklaring?populate=*`),
          axios.get(`${STRAPI_URL}/api/contact-pagina?populate=*`),
        ]);
        setPrivacyData(privacyRes.data.data);
        setContactData(contactRes.data.data);
      } catch (err) {
        console.error('Fout bij het ophalen van footer data:', err);
      }
    };
    fetchFooterData();
  }, []);

  const openLogin = () => setIsLoginModalOpen(true);
  const openRegister = () => setIsRegisterModalOpen(true);
  const verder = () => {
    window.location.href = naInloggen;
  };

  return (
    <div className="page-container seo-page voorbeeld-page publieke-doorloopjes">
      <Header onLoginClick={openLogin} onRegisterClick={openRegister} />

      {isLoginModalOpen && (
        <LoginModal
          onClose={() => setIsLoginModalOpen(false)}
          onLoginSuccess={verder}
          onOpenRegister={() => {
            setIsLoginModalOpen(false);
            setIsRegisterModalOpen(true);
          }}
        />
      )}

      {isRegisterModalOpen && (
        <RegistrationModal onClose={() => setIsRegisterModalOpen(false)} onRegisterSuccess={verder} />
      )}

      <InfoModal
        show={isPrivacyModalOpen}
        onClose={() => setIsPrivacyModalOpen(false)}
        title={privacyData?.title}
        content={privacyData?.body}
        loading={false}
        showSocial={false}
      />

      <InfoModal
        show={isContactModalOpen}
        onClose={() => setIsContactModalOpen(false)}
        title={contactData?.title}
        content={contactData?.body}
        loading={false}
        showSocial={true}
      />

      <main>{children({ openLogin, openRegister })}</main>

      <Footer
        onLoginClick={openLogin}
        onPrivacyClick={() => setIsPrivacyModalOpen(true)}
        onContactClick={() => setIsContactModalOpen(true)}
      />
    </div>
  );
}

export default PubliekePagina;
